export class Login{
    userName:string;
    senha:string;
    idsession: string;
}